export enum ApiResult {
  error,
  ok,
}
